import { render } from "./LootBoxOpenVideo.vue?vue&type=template&id=370bdc72"
import script from "./LootBoxOpenVideo.vue?vue&type=script&lang=js"
export * from "./LootBoxOpenVideo.vue?vue&type=script&lang=js"

import "./LootBoxOpenVideo.vue?vue&type=style&index=0&id=370bdc72&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__